import React, { useState, useEffect, useMemo } from "react";
import Sidebar from "../../component/Sidebar";
import Topbar from "../../component/Topbar";
import { useNavigate } from "react-router-dom";
import {
  FiPlus, FiEye, FiSearch, FiBox, FiDollarSign, FiTag,
  FiChevronsUp, FiChevronsDown, FiFilter, FiZap,
  FiChevronLeft, FiChevronRight, FiLayers, FiEdit, FiX,
} from "react-icons/fi";
import { baseurl, imgurl } from "../../baseurl";
import axios from "axios";

/* ─── CSS ─── */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;600;700;800&family=DM+Sans:wght@400;500;600&display=swap');

:root {
  --ps-teal:      #0a5556;
  --ps-teal-mid:  #0c7172;
  --ps-teal-lite: #14b8a6;
  --ps-gold:      #FFD166;
  --ps-bg:        #eef6f6;
  --ps-white:     #ffffff;
  --ps-border:    rgba(10,85,86,0.10);
  --ps-text:      #0f2a2a;
  --ps-muted:     #5a8080;
  --ps-danger:    #ef4444;
  --ps-success:   #10b981;
  --ps-info:      #3b82f6;
}

@keyframes ps__fadeUp  { from{opacity:0;transform:translateY(16px)} to{opacity:1;transform:translateY(0)} }
@keyframes ps__shimmer { 0%{background-position:-600px 0} 100%{background-position:600px 0} }

.ps__wrap {
  font-family:'DM Sans',sans-serif;
  padding:22px 22px 40px;
  background:var(--ps-bg);
  min-height:100vh;
  animation:ps__fadeUp 0.4s ease both;
}

.ps__hd { display:flex; align-items:flex-start; justify-content:space-between; gap:16px; margin-bottom:20px; flex-wrap:wrap; }
.ps__hd-left { display:flex; align-items:center; gap:14px; }
.ps__hd-icon {
  width:48px; height:48px; border-radius:14px; flex-shrink:0;
  background:linear-gradient(135deg,var(--ps-teal),var(--ps-teal-lite));
  display:flex; align-items:center; justify-content:center;
  font-size:20px; color:#fff; box-shadow:0 6px 18px rgba(10,85,86,0.26);
}
.ps__hd-title { font-family:'Sora',sans-serif; font-size:20px; font-weight:800; color:var(--ps-text); letter-spacing:-0.03em; margin:0 0 3px; }
.ps__hd-sub   { font-size:12.5px; color:var(--ps-muted); margin:0; }
.ps__cta {
  display:inline-flex; align-items:center; gap:8px;
  padding:10px 20px; border-radius:12px; border:none; cursor:pointer;
  font-size:13.5px; font-family:'Sora',sans-serif; font-weight:700; color:#fff;
  background:linear-gradient(135deg,var(--ps-teal),var(--ps-teal-lite));
  box-shadow:0 4px 16px rgba(10,85,86,0.28); transition:transform 0.14s, box-shadow 0.18s;
}
.ps__cta:hover { transform:translateY(-1px); box-shadow:0 8px 24px rgba(10,85,86,0.34); }

.ps__stats { display:flex; gap:12px; margin-bottom:20px; flex-wrap:wrap; }
.ps__stat {
  flex:1; min-width:150px; background:var(--ps-white); border:1px solid var(--ps-border); border-radius:16px;
  padding:16px 18px; box-shadow:0 2px 10px rgba(10,85,86,0.05);
  display:flex; align-items:center; gap:14px; position:relative; overflow:hidden;
}
.ps__stat::before {
  content:''; position:absolute; top:0; left:0; right:0; height:3px;
  background:linear-gradient(90deg,var(--ps-teal),var(--ps-teal-lite),var(--ps-gold));
}
.ps__stat-icon {
  width:44px; height:44px; border-radius:13px; flex-shrink:0;
  background:linear-gradient(135deg,var(--ps-teal),var(--ps-teal-lite));
  display:flex; align-items:center; justify-content:center;
  font-size:19px; color:#fff; box-shadow:0 4px 12px rgba(10,85,86,0.22);
}
.ps__stat-lbl { font-size:11.5px; color:var(--ps-muted); font-weight:500; margin-bottom:3px; }
.ps__stat-val { font-family:'Sora',sans-serif; font-size:17px; font-weight:800; color:var(--ps-text); }

.ps__card {
  background:var(--ps-white); border-radius:20px; border:1px solid var(--ps-border);
  box-shadow:0 2px 20px rgba(10,85,86,0.07),0 8px 40px rgba(0,0,0,0.03);
  overflow:hidden; position:relative;
}
.ps__card::before {
  content:''; position:absolute; top:0; left:0; right:0; height:3px;
  background:linear-gradient(90deg,var(--ps-teal) 0%,var(--ps-teal-lite) 55%,var(--ps-gold) 100%);
}

.ps__toolbar {
  display:flex; align-items:center; justify-content:space-between;
  gap:12px; padding:18px 22px; flex-wrap:wrap; border-bottom:1px solid var(--ps-border);
}
.ps__toolbar-left { display:flex; align-items:center; gap:10px; flex-wrap:wrap; }
.ps__search {
  display:flex; align-items:center; gap:8px; background:#f3fafa;
  border:1.5px solid rgba(10,85,86,0.15); border-radius:10px; padding:8px 13px;
  transition:border-color 0.18s, box-shadow 0.18s;
}
.ps__search:focus-within { border-color:var(--ps-teal); box-shadow:0 0 0 3px rgba(10,85,86,0.09); background:#fff; }
.ps__search-icon  { color:var(--ps-muted); font-size:14px; flex-shrink:0; }
.ps__search-input {
  border:none; outline:none; background:transparent;
  font-size:13px; font-family:'DM Sans',sans-serif; color:var(--ps-text); width:200px;
}
.ps__search-input::placeholder { color:#9ababa; }
.ps__type-select {
  padding:8px 28px 8px 12px; font-size:12.5px; color:var(--ps-text); background:#f3fafa;
  border:1.5px solid rgba(10,85,86,0.15); border-radius:10px; outline:none; cursor:pointer; appearance:none;
  background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='11' height='11' viewBox='0 0 24 24' fill='none' stroke='%235a8080' stroke-width='2.5'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
  background-repeat:no-repeat; background-position:right 9px center; transition:border-color 0.18s;
}
.ps__type-select:focus { border-color:var(--ps-teal); box-shadow:0 0 0 3px rgba(10,85,86,0.09); }
.ps__reset-btn {
  display:inline-flex; align-items:center; gap:5px; padding:7px 12px; border-radius:9px; cursor:pointer;
  font-size:12px; font-family:'Sora',sans-serif; font-weight:700; color:var(--ps-muted);
  background:transparent; border:1.5px solid rgba(10,85,86,0.14); transition:all 0.15s;
}
.ps__reset-btn:hover { color:var(--ps-danger); border-color:rgba(239,68,68,0.25); background:rgba(239,68,68,0.06); }

.ps__table-wrap { overflow-x:auto; }
.ps__table { width:100%; border-collapse:collapse; }
.ps__table thead th {
  font-family:'Sora',sans-serif; font-size:10.5px; font-weight:700;
  letter-spacing:0.09em; text-transform:uppercase; color:var(--ps-teal);
  background:rgba(10,85,86,0.04); padding:11px 18px; white-space:nowrap;
  border-bottom:1px solid var(--ps-border); cursor:pointer; user-select:none;
}
.ps__table thead th:hover { color:var(--ps-teal-lite); }
.ps__sort-icon     { display:inline-flex; vertical-align:middle; margin-left:3px; opacity:.35; }
.ps__sort-icon--on { opacity:1; color:var(--ps-teal-lite); }
.ps__table tbody tr { border-bottom:1px solid rgba(10,85,86,0.055); transition:background 0.13s; }
.ps__table tbody tr:last-child { border-bottom:none; }
.ps__table tbody tr:hover { background:rgba(10,85,86,0.025); }
.ps__table tbody td { padding:13px 18px; font-size:13.5px; color:var(--ps-text); vertical-align:middle; }

.ps__prod-cell { display:flex; align-items:center; gap:12px; }
.ps__prod-img  { width:40px; height:40px; border-radius:11px; object-fit:cover; flex-shrink:0; border:1.5px solid var(--ps-border); }
.ps__prod-name { font-size:13px; font-weight:600; color:var(--ps-text); margin-bottom:2px; }
.ps__prod-uuid { font-size:10px; color:#9ababa; font-family:'Sora',sans-serif; letter-spacing:0.03em; }

.ps__type-badge { display:inline-flex; align-items:center; gap:5px; font-size:11px; font-weight:700; font-family:'Sora',sans-serif; border-radius:50px; padding:3px 10px; white-space:nowrap; }
.ps__type-badge--product { background:rgba(10,85,86,0.09); color:var(--ps-teal); border:1px solid rgba(10,85,86,0.18); }
.ps__type-badge--service  { background:rgba(59,130,246,0.09); color:#2563eb; border:1px solid rgba(59,130,246,0.20); }

.ps__price { font-family:'Sora',sans-serif; font-size:13.5px; font-weight:800; color:var(--ps-text); text-align:right; }
.ps__stock-val { font-family:'Sora',sans-serif; font-size:13px; font-weight:700; text-align:center; }
.ps__stock-val--ok  { color:var(--ps-success); }
.ps__stock-val--low { color:var(--ps-danger); }
.ps__stock-unit { font-size:11px; color:var(--ps-muted); font-weight:400; margin-left:3px; }
.ps__stock-na   { font-size:12px; color:#b0cece; text-align:center; }

.ps__tracked-badge { display:inline-flex; align-items:center; gap:5px; font-size:11px; font-weight:700; font-family:'Sora',sans-serif; border-radius:50px; padding:3px 10px; }
.ps__tracked-badge--yes { background:rgba(16,185,129,0.09); color:#047857; border:1px solid rgba(16,185,129,0.22); }
.ps__tracked-badge--no  { background:rgba(10,85,86,0.05); color:var(--ps-muted); border:1px solid var(--ps-border); }
.ps__tracked-dot { width:6px; height:6px; border-radius:50%; flex-shrink:0; }
.ps__tracked-dot--yes { background:#10b981; }
.ps__tracked-dot--no  { background:#b0cece; }

.ps__actions { display:flex; align-items:center; gap:5px; justify-content:flex-end; }
.ps__action-btn {
  width:30px; height:30px; border-radius:9px; border:none; cursor:pointer;
  display:flex; align-items:center; justify-content:center; font-size:14px;
  color:var(--ps-muted); background:transparent; border:1.5px solid var(--ps-border); transition:all 0.15s;
}
.ps__action-btn--edit:hover { background:rgba(10,85,86,0.09); color:var(--ps-teal); border-color:rgba(10,85,86,0.22); }
.ps__action-btn--view:hover { background:rgba(59,130,246,0.08); color:#2563eb; border-color:rgba(59,130,246,0.22); }

.ps__skel { border-radius:8px; background:linear-gradient(90deg,#e8f4f4 0%,#d0eded 50%,#e8f4f4 100%); background-size:600px 100%; animation:ps__shimmer 1.4s linear infinite; }
.ps__skel-img { width:40px; height:40px; border-radius:11px; flex-shrink:0; }

.ps__empty { padding:60px 20px; text-align:center; }
.ps__empty-icon { width:56px; height:56px; border-radius:18px; margin:0 auto 14px; background:rgba(10,85,86,0.07); display:flex; align-items:center; justify-content:center; font-size:24px; }
.ps__empty-title { font-family:'Sora',sans-serif; font-size:15px; font-weight:700; color:var(--ps-text); margin-bottom:5px; }
.ps__empty-sub   { font-size:13px; color:var(--ps-muted); }

.ps__footer {
  display:flex; align-items:center; justify-content:space-between;
  padding:14px 22px; border-top:1px solid var(--ps-border); flex-wrap:wrap; gap:10px;
}
.ps__footer-info { font-size:12.5px; color:var(--ps-muted); }
.ps__footer-info strong { color:var(--ps-text); }

.ps__pagination { display:flex; align-items:center; gap:4px; }
.ps__page-btn {
  min-width:32px; height:32px; border-radius:9px; border:1.5px solid var(--ps-border);
  background:var(--ps-white); font-size:12px; font-weight:600; color:var(--ps-muted);
  cursor:pointer; padding:0 8px; display:flex; align-items:center; justify-content:center; gap:3px; transition:all 0.15s;
}
.ps__page-btn:hover:not(:disabled) { border-color:var(--ps-teal); color:var(--ps-teal); background:rgba(10,85,86,0.05); }
.ps__page-btn--active { background:var(--ps-teal) !important; border-color:var(--ps-teal) !important; color:#fff !important; }
.ps__page-btn:disabled { opacity:.35; cursor:not-allowed; }

@media(max-width:700px){ .ps__search-input{width:130px;} }
`;

const formatCurrency = (amount) =>
  Number(amount).toLocaleString("en-IN", {
    style:"currency", currency:"INR",
    minimumFractionDigits:2, maximumFractionDigits:2,
  });

function CustomPagination({ totalItems, itemsPerPage, currentPage, onPageChange }) {
  const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));
  if (totalItems === 0) return null;
  let start = Math.max(1, currentPage - 2), end = Math.min(totalPages, currentPage + 2);
  const pages = [];
  for (let i = start; i <= end; i++) pages.push(i);
  return (
    <div className="ps__pagination">
      <button className="ps__page-btn" onClick={() => onPageChange(1)} disabled={currentPage === 1}><FiChevronLeft size={12} /></button>
      {pages.map(p => (
        <button key={p} className={`ps__page-btn ${currentPage === p ? "ps__page-btn--active" : ""}`} onClick={() => onPageChange(p)}>{p}</button>
      ))}
      <button className="ps__page-btn" onClick={() => onPageChange(totalPages)} disabled={currentPage === totalPages}><FiChevronRight size={12} /></button>
    </div>
  );
}

function AllProductService() {
  const navigate = useNavigate();
  const [products, setProducts]       = useState([]);
  const [loading, setLoading]         = useState(true);
  const token = localStorage.getItem("auth_token");
  const [searchTerm, setSearchTerm]   = useState("");
  const [typeFilter, setTypeFilter]   = useState("All");
  const [sortBy, setSortBy]           = useState({ key:"created_at", direction:"desc" });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage]                = useState(10);

  const fetchProducts = async () => {
    setLoading(true);
    try { 
      const response = await axios.get(`${baseurl}getAllProducts`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      console.log("response", response);

      if (response.data.success) setProducts(response.data.data);
    } catch (error) {
      console.error("Fetch Error:", error);
    } finally {
      setTimeout(() => setLoading(false), 600);
    }
  };

  useEffect(() => { fetchProducts(); }, []);

  const processedProducts = useMemo(() => {
    let list = [...products];
    if (searchTerm.trim()) {
      const s = searchTerm.trim().toLowerCase();
      list = list.filter(i =>
        i.product_data.name.toLowerCase().includes(s) ||
        i.product_uuid.toLowerCase().includes(s)
      );
    }
    if (typeFilter !== "All") list = list.filter(i => i.type === typeFilter);
    list.sort((a, b) => {
      let aVal = ["name","rate"].includes(sortBy.key) ? a.product_data[sortBy.key] : a[sortBy.key];
      let bVal = ["name","rate"].includes(sortBy.key) ? b.product_data[sortBy.key] : b[sortBy.key];
      let cmp  = (sortBy.key === "rate" || sortBy.key === "current_stock")
        ? Number(aVal || 0) - Number(bVal || 0)
        : String(aVal).localeCompare(String(bVal));
      return sortBy.direction === "asc" ? cmp : -cmp;
    });
    return list;
  }, [products, searchTerm, typeFilter, sortBy]);

  const totalItems = processedProducts.length;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex   = Math.min(startIndex + itemsPerPage, totalItems);
  const paginated  = processedProducts.slice(startIndex, endIndex);

  const kpis = useMemo(() => {
    const total      = products.length;
    const totalStock = products.reduce((s, p) => s + parseFloat(p.current_stock || 0), 0);
    const totalValue = products.reduce((s, p) => s + (p.product_data.rate * (parseFloat(p.current_stock) || 0)), 0);
    return { total, totalStock, totalValue: formatCurrency(totalValue) };
  }, [products]);

  const handleSort = (key) => setSortBy(prev => ({
    key, direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
  }));

  const SortIcon = ({ columnKey }) => {
    const isActive = sortBy.key === columnKey;
    const cls = `ps__sort-icon${isActive ? " ps__sort-icon--on" : ""}`;
    return isActive && sortBy.direction === "asc"
      ? <FiChevronsUp size={13} className={cls} />
      : <FiChevronsDown size={13} className={cls} />;
  };

  return (
    <>
      <style>{CSS}</style>
      <Topbar />
      <Sidebar />

      <main className="main-wrapper">
        <div className="ps__wrap">

          {/* Header */}
          <div className="ps__hd">
            <div className="ps__hd-left">
              <div className="ps__hd-icon"><FiBox /></div>
              <div>
                <div className="ps__hd-title">Items Inventory</div>
                <div className="ps__hd-sub">Track and manage your products and service catalog</div>
              </div>
            </div>
            <button className="ps__cta" onClick={() => navigate("/product-add")}>
              <FiPlus size={15} /> Add New Item
            </button>
          </div>

          {/* Stats */}
          <div className="ps__stats">
            {[
              { label:"Total Items",     value: kpis.total,                        icon:<FiLayers size={20} /> },
              { label:"Current Stock",   value: kpis.totalStock.toLocaleString(),   icon:<FiBox size={20} /> },
              { label:"Stock Valuation", value: kpis.totalValue,                    icon:<FiDollarSign size={20} /> },
            ].map((kpi, idx) => (
              <div className="ps__stat" key={idx}>
                <div className="ps__stat-icon">{kpi.icon}</div>
                <div>
                  <div className="ps__stat-lbl">{kpi.label}</div>
                  <div className="ps__stat-val">
                    {loading ? <div className="ps__skel" style={{ width:80, height:14, marginTop:4 }} /> : kpi.value}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Card */}
          <div className="ps__card">

            {/* Toolbar */}
            <div className="ps__toolbar">
              <div className="ps__toolbar-left">
                <div className="ps__search">
                  <FiSearch className="ps__search-icon" />
                  <input className="ps__search-input" placeholder="Search name or ID…"
                    value={searchTerm}
                    onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }} />
                </div>
                <select className="ps__type-select" value={typeFilter}
                  onChange={(e) => { setTypeFilter(e.target.value); setCurrentPage(1); }}>
                  <option value="All">All Types</option>
                  <option value="Product">Product</option>
                  <option value="Service">Service</option>
                </select>
                {(searchTerm || typeFilter !== "All") && (
                  <button className="ps__reset-btn" onClick={() => { setSearchTerm(""); setTypeFilter("All"); }}>
                    <FiX size={12} /> Reset
                  </button>
                )}
              </div>
            </div>

            {/* Table */}
            <div className="ps__table-wrap">
              <table className="ps__table">
                <thead>
                  <tr>
                    <th onClick={() => handleSort("name")}>Product Details <SortIcon columnKey="name" /></th>
                    <th onClick={() => handleSort("type")}>Type <SortIcon columnKey="type" /></th>
                    <th style={{ textAlign:"right" }} onClick={() => handleSort("rate")}>Price <SortIcon columnKey="rate" /></th>
                    <th style={{ textAlign:"center" }} onClick={() => handleSort("current_stock")}>Stock <SortIcon columnKey="current_stock" /></th>
                    <th style={{ textAlign:"center" }}>Inventory</th>
                    <th style={{ textAlign:"right" }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    Array.from({ length: 6 }).map((_, i) => (
                      <tr key={i}>
                        <td>
                          <div style={{ display:"flex", alignItems:"center", gap:12 }}>
                            <div className="ps__skel ps__skel-img" />
                            <div>
                              <div className="ps__skel" style={{ width:120, height:13, marginBottom:6 }} />
                              <div className="ps__skel" style={{ width:80, height:10 }} />
                            </div>
                          </div>
                        </td>
                        {[60,70,50,80,60].map((w, j) => (
                          <td key={j}><div className="ps__skel" style={{ width:w, height:13, marginLeft: j>1?"auto":0 }} /></td>
                        ))}
                      </tr>
                    ))
                  ) : paginated.length === 0 ? (
                    <tr><td colSpan="6">
                      <div className="ps__empty">
                        <div className="ps__empty-icon">🔍</div>
                        <div className="ps__empty-title">No items found</div>
                        <div className="ps__empty-sub">Try adjusting your search or type filter.</div>
                      </div>
                    </td></tr>
                  ) : paginated.map((item) => (
                    <tr key={item.product_uuid}>
                      <td>
                        <div className="ps__prod-cell">
                          <img className="ps__prod-img"
                            src={item.product_data.image_path ? `${imgurl}${item.product_data.image_path}` : "https://via.placeholder.com/40"}
                            alt="" />
                          <div>
                            <div className="ps__prod-name">{item.product_data.name}</div>
                            <div className="ps__prod-uuid">{item.product_uuid}</div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <span className={`ps__type-badge ${item.type === "Product" ? "ps__type-badge--product" : "ps__type-badge--service"}`}>
                          {item.type}
                        </span>
                      </td>
                      <td><div className="ps__price">{formatCurrency(item.product_data.rate)}</div></td>
                      <td>
                        {item.type === "Product" ? (
                          <div className={`ps__stock-val ${parseFloat(item.current_stock) <= item.product_data.min_order_qty ? "ps__stock-val--low" : "ps__stock-val--ok"}`}>
                            {parseFloat(item.current_stock)}<span className="ps__stock-unit">{item.product_data.unit}</span>
                          </div>
                        ) : <div className="ps__stock-na">N/A</div>}
                      </td>
                      <td style={{ textAlign:"center" }}>
                        <span className={`ps__tracked-badge ${item.product_data.inventory_tracked ? "ps__tracked-badge--yes" : "ps__tracked-badge--no"}`}>
                          <span className={`ps__tracked-dot ${item.product_data.inventory_tracked ? "ps__tracked-dot--yes" : "ps__tracked-dot--no"}`} />
                          {item.product_data.inventory_tracked ? "Tracked" : "Not Tracked"}
                        </span>
                      </td>
                      <td>
                        <div className="ps__actions">
                          <button className="ps__action-btn ps__action-btn--edit" onClick={() => navigate(`/edit-product/${item.product_uuid}`)} title="Edit"><FiEdit size={13} /></button>
                          <button className="ps__action-btn ps__action-btn--view" onClick={() => navigate(`/view-product/${item.product_uuid}`)} title="View"><FiEye size={13} /></button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Footer */}
            <div className="ps__footer">
              <div className="ps__footer-info">
                {loading ? "Syncing…" : <><strong>{startIndex + 1}</strong>–<strong>{endIndex}</strong> of <strong>{totalItems}</strong> items</>}
              </div>
              {!loading && <CustomPagination totalItems={totalItems} itemsPerPage={itemsPerPage} currentPage={currentPage} onPageChange={setCurrentPage} />}
            </div>

          </div>
        </div>
      </main>
    </>
  );
}

export default AllProductService;
